<template>
  <div class="bgc" style="overflow:hidden">
    <!-- <Canvas2></Canvas2> -->
    <el-container>
      <div class="tip">
        <p>字体转换服务</p>
      </div>
      <el-form :model="ruleForm" :rules="rules" class="demo-ruleForm" ref="ruleForm" status-icon>
        <el-form-item label prop="account">
          <el-input
            @keyup.native.enter="submitForm()"
            autocomplete="off"
            placeholder="用户名"
            type="text"
            v-model="ruleForm.account"
          ></el-input>
        </el-form-item>
        <el-form-item label prop="password">
          <el-input
            @keyup.native.enter="submitForm()"
            autocomplete="off"
            placeholder="密码"
            type="password"
            v-model="ruleForm.password"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="submitForm()" type="primary">提交</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        account: '',
        password: ''
      },

      rules: {
        account: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        pass: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    let metaTag = document.createElement('meta')
    metaTag.name = 'viewport'
    metaTag.content =
      'width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no'
    document.getElementsByTagName('head')[0].appendChild(metaTag)
  },
  components: {},
  methods: {
    submitForm() {
      let _this = this
      this.$api.search.login(this.ruleForm).then(res => {
        if (res.status == 200) {
          if (res.data.code == 0) {
            this.$store.commit('token', res.data.data.token)
            this.$store.commit('memberId', res.data.data.memberId)
            this.$store.commit('usertype', res.data.data.type)
            this.$store.commit('username', _this.ruleForm.account)
            _this.$router.push({
              path: '/layout/transform'
            })
          } else if (res.data.code == 1000) {
            this.$message({
              message: '账户名错误',
              type: 'error',
              duration: 1000
            })
          } else if (res.data.code == 1001) {
            this.$message({
              message: '密码错误',
              type: 'error',
              duration: 1000
            })
          } else {
            this.$message({
              message: '系统忙,请重试',
              type: 'error',
              duration: 1000
            })
          }
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.bgc {
  height: 100vh;
  width: 100vw;
  background-color: #333;
}

.bgc .el-container {
  width: 32rem;
  height: 21rem;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -10.5rem;
  margin-left: -16rem;
  padding: 25px;
  border-radius: 5px;
  text-align: center;
  background-color: #fff;
  font-size: 1.6rem;
}

.bgc .el-container .el-form {
  width: 27rem;
  margin: 0 auto;
}

// @media screen and (max-width: 1000px) {
//   .bgc .el-container {
//     width: 64rem;
//     height: 42rem;
//     margin-top: -21rem;
//     margin-left: -32rem;
//     padding: 2.5rem;
//     border-radius: 0.5rem;
//   }
//   .bgc .el-container .el-form {
//     width: 54rem;
//     margin: 0 auto;
//   }
// }

.tip {
  position: absolute;
  width: 100%;
  top: -100px;
  left: 0;
  user-select: none;
}

.tip p {
  font-size: 34px;
  color: #fff;
}
</style>
